import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, makeEntityChildrenIdsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import { setSelectedItem } from "./actions";
import Component, { type ImageGalleryActionProps, type ImageGalleryMapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  const itemsIdsSelector = makeEntityChildrenIdsSelector();

  const thumbnailsPositionSelector = getSettingValueSelector(TargetSelector.Entity, "thumbnailsPosition");

  return (state: AppState, props: RootContainerProps): ImageGalleryMapProps => {
    const localState = localStateSelector(state, props);
    const thumbnailsPosition = thumbnailsPositionSelector(state, props);

    return {
      className: classnames("wsc_image_gallery", `thumbnails-${thumbnailsPosition}`),
      itemsIds: itemsIdsSelector(state, props),
      selectedItemId: localState.selectedItemId,
      thumbnailsPosition,
      ...props
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ImageGalleryActionProps => ({
  setSelectedItem: (itemId: string) => dispatch(setSelectedItem(getEntityRef(props), itemId))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
